module.exports = __webpack_public_path__ + "img/page2-bg.e6f990cd.png";